import { render } from "./EditResTemplate.vue?vue&type=template&id=715aed26"
import script from "./EditResTemplate.vue?vue&type=script&lang=js"
export * from "./EditResTemplate.vue?vue&type=script&lang=js"

import "./EditResTemplate.vue?vue&type=style&index=0&id=715aed26&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__